import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 px-4 bg-navy-900 relative" data-id="element-68">
      <div className="max-w-2xl mx-auto" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="bg-navy-800 rounded-2xl p-8 md:p-10 border border-green-500/30 text-center relative overflow-hidden" data-id="element-70">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-green-500 to-transparent" data-id="element-71" />

          <div className="w-20 h-20 rounded-full bg-green-500/15 flex items-center justify-center mx-auto mb-6 border border-green-500/30" data-id="element-72">
            <ShieldCheck className="w-10 h-10 text-green-400" data-id="element-73" />
          </div>

          <h3 className="text-3xl md:text-4xl font-bebas text-white mb-2" data-id="element-74">
            🛡️ Garantía de 7 días
          </h3>

          <p className="text-xl text-green-400 font-semibold mb-4" data-id="element-75">
            100% de tu dinero de vuelta
          </p>

          <p className="text-white/70 leading-relaxed max-w-lg mx-auto" data-id="element-76">
            Si no te convence, te devolvemos el 100% de tu dinero. Sin
            preguntas, sin letra chica, sin vueltas. Tenés 7 días completos para
            probarlo y decidir. El riesgo es cero.
          </p>
        </motion.div>
      </div>
    </section>;
}